<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-stock-transfer-request-sidebar ref="stockTransferRequestSidebar" />

    <div class="flex justify-between mb-5">
      <div class="flex justify-between">
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit.</p>
      </div>
      <div class="flex justify-end">
        <vs-button
          @click="onClickShowTransferRequestSidebar"
          icon="add"
          class="mr-3"
          type="relief"
          color="primary"
          >Request stock transfer</vs-button
        >
        <vs-button icon="add" type="relief" color="primary"
          >New stock transfer</vs-button
        >
      </div>
    </div>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        pagination
        max-items="20"
        search
        :data="filteredStockTransfers"
        v-model="selected"
        @selected="onClicked(selected.id)"
      >
        <template slot="header">
          <vs-button
            v-for="filter in stateMapping"
            :key="filter.value"
            :class="{
              'rounded-l-lg': filter.value === stateMapping[0].value,
              'rounded-r-lg':
                filter.value === stateMapping[stateMapping.length - 1].value,
            }"
            class="rounded-none px-3 py-3"
            :style="
              filter.value !== stateMapping[0].value
                ? 'border-left: 1px solid #666 !important'
                : ''
            "
            style="margin-top: -10px"
            :color="selectedStateValue === filter.value ? 'primary' : 'grey'"
            @click="
              selectedStateValue === filter.value
                ? (selectedStateValue = null)
                : (selectedStateValue = filter.value)
            "
            :icon="selectedStateValue === filter.value ? 'check' : ''"
          >
            {{ filter.label }}
          </vs-button>
        </template>
        <template slot="thead">
          <vs-th>Request</vs-th>
          <vs-th sort-key="state">State</vs-th>
          <vs-th>Products</vs-th>
          <vs-th sort-key="fromVenueName">From venue</vs-th>
          <vs-th sort-key="toVenueName">To venue</vs-th>
          <vs-th sort-key="createdBy.username">Created by</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
          <vs-th>Processed By</vs-th>
          <vs-th sort-key="processedAt">Processed at</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img width="40" :src="ProductIcon" />
                  <div class="flex flex-col ml-4">
                    <p>Request</p>
                    <div>
                      <small>{{
                        tr.initiatingVenueId &&
                        tr.initiatingVenueId.id == activeVenueId
                          ? "Outgoing"
                          : "Incoming"
                      }}</small>
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <vs-chip
                  class="whitespace-no-wrap"
                  :color="getStateColor(tr.state)"
                >
                  {{ getStateLabel(tr.state) }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip class="whitespace-no-wrap">
                  {{ tr.stockTransferAmounts.length }} product{{
                    tr.stockTransferAmounts.length != 1 ? "s" : ""
                  }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <code v-if="tr.fromVenueName">
                  {{ tr.fromVenueName }}
                </code>
              </vs-td>
              <vs-td>
                <code v-if="tr.toVenueName">
                  {{ tr.toVenueName }}
                </code>
              </vs-td>
              <vs-td>
                {{ tr.createdBy.username }}
              </vs-td>
              <vs-td>
                <div class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.createdAt | formatDate }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.processedBy">
                  {{ tr.processedBy.username }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.processedBy" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.processedAt | formatDate }}
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/storage_icon.png";
import HandleStockTransferRequestSidebar from "./HandleStockTransferRequestSidebar.vue";

export default {
  components: {
    HandleStockTransferRequestSidebar,
  },
  data() {
    return {
      isLoading: true,
      ProductIcon,

      selectedStateValue: null,
      selected: null,
    };
  },
  methods: {
    getStateLabel(state) {
      // Get first state that matches in array stateFilters and return the label of that
      const match = this.stateMapping.find((filter) => filter.value === state);
      return match ? match.label : state;
    },
    getStateColor(state) {
      // Get first state that matches in array stateFilters and return the color of that
      const match = this.stateMapping.find((filter) => filter.value === state);
      return match ? match.color : state;
    },

    onClickShowTransferRequestSidebar() {
      this.$refs.stockTransferRequestSidebar.showNewRequest();
    },
    onClicked(stockTransferId) {
      this.$refs.stockTransferRequestSidebar.show(stockTransferId);
    },
    confirmAddLocation(type) {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: "Add location",
        text: "Are you sure you want to add a new stock location?",
        accept: () => {
          this.addLocation(type);
        },
      });
    },
    addLocation(type) {
      console.log("addLocation", type);
      this.$store
        .dispatch("venues/addPimStockLocation", {
          type: type,
          venueId: this.activeVenueId,
        })
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Location added",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: error.message,
            color: "danger",
          });
        });
    },
    confirmRemovePimStockLocation(location) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Remove location",
        text: "Are you sure you want to remove this location?",
        accept: () => {
          this.removePimStockLocation(location);
        },
      });
    },
    removePimStockLocation(location) {
      this.$store
        .dispatch("venues/deletePimStockLocation", {
          id: location,
          venueId: this.activeVenueId,
        })
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Location removed",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: error.message,
            color: "danger",
          });
        });
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeVenueId: "venues/activeVenueId",
      stockTransfers: "stockTransfers/stockTransfers",
      stateMapping: "stockTransfers/stateMapping",
    }),

    filteredStockTransfers() {
      return this.stockTransfers
        .filter((stockTransfer) => {
          if (this.selectedStateValue)
            return stockTransfer.state === this.selectedStateValue;

          return true;
        })
        .slice()
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
  },

  async created() {
    this.isLoading = true;
    try {
      await this.$store.dispatch(
        "stockTransfers/getStockTransfers",
        this.activeVenueId
      );
    } catch (err) {
      let message = err;
      if (err.error) message = err.error;

      this.$vs.notify({
        title: "Could not load stock transfers",
        text: message,
        color: "danger",
        time: 5000,
      });
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
